import { PluginObject } from 'vue';
import axios, { AxiosRequestConfig } from 'axios';

export interface VueAxiosOptions {
  host?: string;
  port?: number;
  prefix?: string;
  https?: boolean;
  credentials?: boolean;
}

const plugin: PluginObject<VueAxiosOptions> = {
  install(Vue, pluginOptions) {
    const defaultHost = pluginOptions?.host || process.env.VUE_APP_API_HOST || process.env.HOST;
    const defaultPort = pluginOptions?.port || process.env.VUE_APP_API_PORT || process.env.PORT;
    const prefix = pluginOptions?.prefix || process.env.VUE_APP_API_PREFIX || '/';

    const useHttps = Boolean(pluginOptions?.https || ((process.env.VUE_APP_API_HTTPS as string) === 'true'));

    const options: AxiosRequestConfig = {
      baseURL: `http://${defaultHost}${defaultPort ? `:${defaultPort}` : ''}${prefix}`,
      withCredentials: pluginOptions?.credentials || false,
    };

    if (useHttps === true) {
      const convert2https = (s: string) => s.replace('http://', 'https://');
      options.baseURL = convert2https(options.baseURL as string);
    }

    const axiosApi = axios.create(options);

    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$axios = axiosApi;
  },
};

export default plugin;
